window.estimateShippingArrival = function (shipMethod) {   
  var currentDate = new Date();
  var shipDate = new Date();  
  var arrivalDateFrom = new Date();
  var arrivalDateTo = new Date();
  var shipLag = 0;
  var arrivalDateFromLag = 0;
  var arrivalDateToLag = 0;
  const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  
  if (currentDate.getDay() >= 1 && currentDate.getDay() <= 4) {
    switch (window.leadTime) {
      case 1: 
        shipLag = 1;
        break;

      case 2: 
        shipLag = 3;
        break;
        
      case 3: 
        shipLag = 3;
        break;
        
      case 7: 
        shipLag = 7;
        break;

      case 10: 
        shipLag = 10;
        break;
        
      case 30: 
        shipLag = 30;
        break;                
    }     
  } else {
    switch (window.leadTime) {
      case 1: 
        shipLag = 3;
        break;

      case 2: 
        shipLag = 6;
        break;
        
      case 3: 
        shipLag = 6;
        break;
        
      case 7: 
        shipLag = 10;
        break;

      case 10: 
        shipLag = 13;
        break;
        
      case 30: 
        shipLag = 33;
        break;               
    }    
  }
  
  switch (shipMethod) {
    case 'Economy Shipping (7-10 Business days)':
      arrivalDateFromLag += 10;
      arrivalDateToLag += 12;
      break;
     
    case 'Free Economy Shipping (7-10 Business days)': 
      arrivalDateFromLag += 10;
      arrivalDateToLag += 12;      
      break;     
     
    case 'Standard Shipping (3-8 Business days)':  
      arrivalDateFromLag += 3;
      arrivalDateToLag += 8;      
      break;  
     
    case 'UPS 2nd Day Air (2 Business days)':  
      arrivalDateFromLag += 2;
      arrivalDateToLag += 2;      
      break; 
     
    case 'UPS Next Day Air (1 Business day)':  
      arrivalDateFromLag += 1;
      arrivalDateToLag += 1;      
      break;  
      
    case 'Instore Pickup (Richmond, Virginia)':  
      arrivalDateFromLag += 1;
      arrivalDateToLag += 1;      
      break;      
  }  
  
  
  shipDate.setDate(currentDate.getDate() + shipLag);
  arrivalDateFrom.setDate(currentDate.getDate() + (shipLag + arrivalDateFromLag));
  arrivalDateTo.setDate(currentDate.getDate() + (shipLag + arrivalDateToLag));
      
  var shipDateHTML = monthNames[shipDate.getMonth()] + ' ' + shipDate.getDate() + ', ' + shipDate.getFullYear();
  
  var arrivalDateHTML = '<em class="estimated-arrival-dt">Estimated Arrival: <span>' + monthNames[arrivalDateFrom.getMonth()] + ' ' + arrivalDateFrom.getDate() + ', ' + arrivalDateFrom.getFullYear();
  if (arrivalDateFromLag != arrivalDateToLag ) {
      arrivalDateHTML += ' - ' + monthNames[arrivalDateTo.getMonth()] + ' ' + arrivalDateTo.getDate() + ', ' + arrivalDateTo.getFullYear();
  }
  arrivalDateHTML += '</span></em>';
  
  if (shipMethod == 'none') {
    document.getElementById("productFormShipDate").innerHTML = shipDateHTML;   
  }  else if ((arrivalDateFromLag+arrivalDateToLag) != 0) {
    return arrivalDateHTML;
  } else {
    return '';
  }
  
}

estimateShippingArrival('none');